import React from 'react';
import { connect } from "react-redux";
import { getPageDataAction, getQuestionListAction } from "../../store/connectint/action";
import QAListComponent from "../../components/connectint/QAListComponent";
import LoaderComponent from '../../components/layout/loaderComponent';
import ErrorContainer from "../../containers/ErrorContainer";
import ReactGA from 'react-ga4';

class QAListContainer extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isBackBtn: (this.props.match.params.searchKey) ? true : false,
      curQuesKey: (this.props.match.params.searchKey) ? this.props.match.params.searchKey : 'primary',
    }
    this.selectedQues = [];
    //this.nextQuestion = this.nextQuestion.bind(this);
  }


  shouldComponentUpdate(nextProps, nextState) {

    if ((nextProps.location.state) && nextProps.match.params.searchKey !== this.state.curQuesKey) {
      this.setState({
        isBackBtn: true,
        curQuesKey: nextProps.match.params.searchKey
      })
      this.props.getQuestionList(nextProps.match.params.searchKey);
      return true;
    }

    if (this.state.curQuesKey !== "primary" && !nextProps.match.params.searchKey) {
      this.props.getQuestionList('primary');
      this.setState({
        isBackBtn: false,
        curQuesKey: 'primary'
      })
      return true;
    } else {
      return true;
    }
  }

  /**
   * @method: To load next question
   * @param: current selected question Key
   * @return: Objects of question list
   */
  nextQuestion = (question) => {
    const { key, value, articleID } = question;

    if (key !== 'articleID' && !articleID) {

      ReactGA.event('Click', {
        category: 'SelectConnectAnswer',
        action: 'Click',
        event_category: 'SelectConnectAnswer',
        event_action: 'Click',
        event_label : this.state.curQuesKey === 'primary' ? `${value}` : `${value} ( ${this.state.curQuesKey} )`,
        UserID: (this.props.authData.auth.userId) ?  this.props.authData.auth.userId : 'noAuth'
      });

      this.props.getQuestionList(key);
      this.setState({
        isBackBtn: true,
        curQuesKey: key
      })
      this.selectedQues.push(key);
      this.props.history.push({
        pathname: '/connectint/' + key,
        state: { curQuesKey: key }
      });

    } else {

      ReactGA.event('Click', {
        category: 'SelectConnectFinal',
        action: 'Click',
        event_category: 'SelectConnectFinal',
        event_action: 'Click',
        event_label: `${value} ( ${this.state.curQuesKey} )`,
        UserID: (this.props.authData.auth.userId) ?  this.props.authData.auth.userId : 'noAuth'
      });

      this.props.history.push({
        pathname: '/troublesht/article/' + articleID,
        state: { searchOption: {}, title: '' }
      });
    }

  }

  /**
* @method: To load previous question
* @param: current selected question Key
* @return: Objects of question list
*/
  preQuestion = (e) => {

    this.selectedQues.pop(this.state.curQuesId);

    let preQuesKey = this.selectedQues[this.selectedQues.length - 1];
    preQuesKey = (preQuesKey) ? preQuesKey : 'primary';
    this.props.getQuestionList(preQuesKey);
    this.setState({
      isBackBtn: (preQuesKey === 'primary') ? false : true,
      curQuesKey: preQuesKey
    })

  }



  /**
   * componentDidMount method to load pre needed data like page title, heading etc.
   */
  componentDidMount() {

    this.props.getPageData();
    this.props.getQuestionList(this.state.curQuesKey);
  }


  /**
   * @render to load the view file
   */
  render() {

    return (

      this.props.questionList && this.props.questionList.hasOwnProperty('statusCode') ?
        (this.props.questionList.statusCode === 200 ?
          <QAListComponent pageData={this.props.pageData} nextQuestion={this.nextQuestion} preQuestion={this.preQuestion} backBtn={this.state.isBackBtn} questionList={this.props.questionList} /> : <ErrorContainer />) : <LoaderComponent />

    )
  }

}


/** @mapDispatchToProps
 *  dispatch method to props  
 */

const mapDispatchToProps = {
  getPageData: getPageDataAction,
  getQuestionList: getQuestionListAction,
};

/** @mapStateToProps
 *  map state to props  
 */

const mapStateToProps = (state) => ({
  pageData: state.connectint.pageData,
  questionList: state.connectint.QuestionList,
  authData: state.auth
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QAListContainer);
